import React from "react"
import { useSelector } from "react-redux"
import { Table, Tag, Skeleton, Tooltip } from "antd"
import { Link } from "react-router-dom"
import moment from "moment"

import { selectTodaysRuns, selectTodaysRunsLoading } from "../clientBatchingSlice"

export default function TodaysRunsTable() {
    const runs = useSelector(selectTodaysRuns)
    const loading = useSelector(selectTodaysRunsLoading)

    return (
        <div className="muc-table card">
            <div className="card-body">
                {/* one wrapper: .card-body is a flex row */}
                <div>
                    <div className="card-body-heading">
                        <div className="badged-header">
                            <h2>Today's Runs</h2>
                            <div className="badge">{runs.length}</div>
                        </div>
                    </div>

                    <p className="p-10">
                        Runs swept today, plus any run still open from an earlier day — an open run keeps holding
                        its clients until it is finalized or discarded.
                    </p>

                    <Skeleton active loading={loading && runs.length === 0}>
                        <Table dataSource={runs} rowKey={(r) => r.id} pagination={false}>
                            <Table.Column
                                title="Run"
                                key="id"
                                // A finalized run opens on its result, which is where the batches
                                // and their files are -- and how A/R finds a run whose file
                                // generation never completed.
                                render={(text, record) => (
                                    <Link
                                        to={`/client_batching/runs/${record.id}${record.finalized ? "/finalize" : ""}`}
                                    >
                                        #{record.id}
                                    </Link>
                                )}
                            />
                            <Table.Column
                                title="Status"
                                key="finalized"
                                render={(text, record) =>
                                    record.finalized ? (
                                        <Tag color="green">Finalized</Tag>
                                    ) : (
                                        <Tag color="blue">Open</Tag>
                                    )
                                }
                            />
                            <Table.Column title="Swept by" key="user_name" dataIndex="user_name" />
                            <Table.Column
                                title="Clients"
                                key="client_names"
                                render={(text, record) => (record.client_names || []).join(", ")}
                            />
                            <Table.Column title="Bills" key="bill_count" dataIndex="bill_count" align="right" />
                            <Table.Column title="Excluded" key="excluded_count" dataIndex="excluded_count" align="right" />
                            <Table.Column title="Withheld" key="withheld_count" dataIndex="withheld_count" align="right" />
                            <Table.Column title="Red-flagged" key="flagged_count" dataIndex="flagged_count" align="right" />
                            <Table.Column
                                title="Stale files"
                                key="stale_file_count"
                                align="right"
                                // Finalized runs only: files built from data that has since changed.
                                render={(text, record) =>
                                    record.stale_file_count > 0 ? (
                                        <Tooltip title="Open the run to regenerate them.">
                                            <Tag color="red">{record.stale_file_count}</Tag>
                                        </Tooltip>
                                    ) : (
                                        "—"
                                    )
                                }
                            />
                            <Table.Column title="Batch date" key="batch_date" dataIndex="batch_date" />
                            <Table.Column
                                title="Swept at"
                                key="created_at"
                                render={(text, record) => moment(record.created_at).format("MMM D, h:mm A")}
                            />
                        </Table>
                    </Skeleton>
                </div>
            </div>
        </div>
    )
}
